import { enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';

import { AppModule } from './app/app.module';
import { environment } from './environments/environment';

if (environment.production) {
  enableProdMode();
}

// Self-host the pdf.js worker ng2-pdf-viewer would otherwise load from cdn.jsdelivr.net, which a
// strict script-src CSP blocks (and which we don't want to allow-list, since jsDelivr serves
// arbitrary npm packages). Must be set before any <pdf-viewer> is constructed, hence here in
// main.ts before bootstrap. The matching asset copy is in angular.json.
(window as any).pdfWorkerSrc = '/assets/pdfjs/pdf.worker.min.mjs';

platformBrowserDynamic().bootstrapModule(AppModule)
  .catch(err => console.error(err));
